import { Trans } from "@lingui/react/macro";
import { Plug } from "lucide-react";

import { cn } from "@ando/ui";

import { GROUP_ACCENT } from "../catalog";

/**
 * Small pill rendered below disconnected/unavailable cards. Reads the
 * accent tokens from ``GROUP_ACCENT`` so the "Piano superiore" (gated)
 * variant inherits the canonical warning tone and "Da connettere"
 * inherits the canonical infrastructure (neutral) tone — no inline
 * ``bg-warning/15`` strings to drift apart from the section headers.
 */
export interface StatusChipProps {
  readonly variant: "gated" | "available";
}

export const StatusChip: React.FC<StatusChipProps> = ({ variant }) => {
  const tokens =
    variant === "gated" ? GROUP_ACCENT.compliance : GROUP_ACCENT.infrastructure;
  return (
    <span
      className={cn(
        "mt-1.5 inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 font-medium text-[10px]",
        tokens.chipBg,
        tokens.chipText,
      )}
    >
      <Plug size={10} aria-hidden />
      {variant === "gated" ? (
        <Trans>Piano superiore</Trans>
      ) : (
        <Trans>Da connettere</Trans>
      )}
    </span>
  );
};
StatusChip.displayName = "StatusChip";
